import { render, staticRenderFns } from "./myPos.vue?vue&type=template&id=56e11776"
import script from "./myPos.vue?vue&type=script&lang=js"
export * from "./myPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports